import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Col, Row } from "react-bootstrap";

import { useNavigate } from "react-router-dom";

import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { createWork } from "store/works/actions";
import { EditorComponent } from "components/shared/FormComponents";
import { getCategories } from "store/actions";
import ImagesUpload from "components/shared/ImagesUploader";
const AddSocial = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const { categories } = useSelector((state) => state?.categories);

  const [description, setDescription] = useState("");
  const [images, setImages] = useState([]);

  useEffect(() => {
    dispatch(getCategories());
  }, [dispatch]);

  const onSubmit = (data) => {
    data.description = description;
    data.image = images;

    dispatch(
      createWork({
        data,
        navigate,
        toast,
      })
    );
  };

  return (
    <>
      <div className="acc-form">
        <div className="card">
          <div className="card-head">
            <h4>اضافة عمل جديد</h4>
          </div>
          <div className="card-body">
            <form onSubmit={handleSubmit(onSubmit)}>
              <Col xl={10} md={12}>
                <Row>
                  <Col lg={12} xs={12}>
                    <div className="form-group required">
                      <h5>صور العمل </h5>
                      <div>
                        <ImagesUpload
                          imagesURLs={images}
                          setImageURLs={setImages}
                        />
                      </div>
                    </div>
                  </Col>
                  <Col lg={6} xs={12}>
                    <div className="form-group required">
                      <h5>اسم العمل </h5>
                      <div>
                        <input
                          type="text"
                          className="form-control form-outline"
                          placeholder="اسم العمل "
                          {...register("title", { required: true })}
                        />
                      </div>
                      <p className="error-hint">
                        {errors?.title && "يرجي ادخال اسم العمل "}
                      </p>
                    </div>
                  </Col>
                  <Col lg={6} xs={12}>
                    <div className="form-group required">
                      <h5>تصنيف العمل </h5>
                      <div>
                        <select
                          className="form-control form-outline form-select"
                          {...register("category", { required: true })}
                        >
                          <option value="">اختر تصنيف العمل</option>
                          {categories?.map((category, index) => (
                            <option value={category._id} key={index}>
                              {category.name}
                            </option>
                          ))}
                        </select>
                      </div>
                      <p className="error-hint">
                        {errors?.category && "يرجي ادخال اسم العمل "}
                      </p>
                    </div>
                  </Col>
                  <Col lg={12} xs={12}>
                    <div className="form-group required">
                      <h5>وصف</h5>
                      <div>
                        <EditorComponent
                          name="description"
                          setData={setDescription}
                          initialValue=""
                        />
                      </div>
                      <p className="error-hint">
                        {description === "" && "يرجي ادخال وصف العمل"}
                      </p>
                    </div>
                  </Col>
                  <Col lg={4} xs={12}>
                    <div className="form-group">
                      <button type="submit" className="btn btn-blue">
                        اضافة
                      </button>
                    </div>
                  </Col>
                </Row>
              </Col>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddSocial;
